<template>
	<div>
		<!-- Cabecera -->
		<pm-header>
			<template slot="contenido">
				<div class="row h-100 d-flex align-items-center fondo-header m-0">
					<div
						class="col-12 col-sm-10 offset-sm-1 col-lg-4 offset-lg-1 col-xl-5 offset-xl-2 text-center text-lg-left text-white"
						data-aos="fade-right"
						data-aos-delay="750"
					>
						<p class="fuente-header-titulo p-0 m-0">Te acompañamos</p>
						<p class="fuente-header-subtitulo p-0 m-0">en el logro de tus objetivos.</p>
					</div>
					<div class="col-lg-6 col-xl-3 d-none d-lg-block" data-aos="fade-left" data-aos-delay="500">
						<img class="img-fluid" src="@/assets/img-pub/Difarmer-quiero-ser-cliente.png" />
					</div>
				</div>
			</template>
		</pm-header>

		<!-- Facilitamos -->
		<div class="row p-0 m-0 py-3 py-sm-4 pt-lg-5 pb-lg-3">
			<div class="col-12 col-md-6 col-xl-5 offset-xl-2 d-flex align-items-center">
				<div data-aos="fade-right">
					<p class="fuente-seccion-titulo mb-5">Comprometidos con cumplir tus expectativas de servicio.</p>
					<p class="fuente-seccion-texto p-0 m-0 mt-2 mb-4">
						Tenemos 60 años esforzándonos para brindarte los mejores resultados.
						Trabajar con nosotros es seguridad, es confianza, es sinónimo de oportunidad y progreso.
					</p>
				</div>
			</div>
			<div
				class="col-8 offset-2 col-md-6 offset-md-0 col-xl-3 d-flex align-items-center"
				data-aos="fade-left"
			>
				<img class="img-fluid" src="@/assets/img-pub/Ilustraciones-Difarmer-4.jpg" />
			</div>
		</div>

		<!-- Comentarios -->
		<!-- <div class="row p-0 m-0 fondo-comentario py-3 py-lg-5 d-flex justify-content-center">
			<div class="col-12 col-xl-8">
				<div class="row col-12">
					<div class="text-lg-center">
						<p class="p-0 m-0 fuente-comentario-titulo">Comentarios de nuestros clientes</p>
					</div>
				</div>
				<div class="row col-12 no-gutters d-flex justify-content-center">
					<b-carousel
						:interval="4000"
						class="carousel-quiero-ser-cliente"
						id="carousel-1"
						img-height="480"
						img-width="1024"
						indicators
					>
						<b-carousel-slide caption img-blank>
							<div>
								<figure class="figure">
									<img
										class="img-thumbnail rounded-circle img-comentarios mb-4"
										src="@/assets/img-pub/Collins logo.png"
									/>
								</figure>
								<p
									class="fuente-comentario-texto"
								>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse eros felis, tincidunt a tincidunt eget, convallis vel est. Ut pellentesque ut lacus vel interdum.</p>
							</div>
						</b-carousel-slide>
						<b-carousel-slide caption img-blank>
							<div>
								<figure class="figure">
									<img
										class="img-thumbnail rounded-circle img-comentarios mb-4"
										src="@/assets/img-pub/cmd logo.png"
									/>
								</figure>
								<p
									class="fuente-comentario-texto"
								>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse eros felis, tincidunt a tincidunt eget, convallis vel est. Ut pellentesque ut lacus vel interdum.</p>
							</div>
						</b-carousel-slide>
						<b-carousel-slide caption img-blank>
							<div>
								<figure class="figure">
									<img
										class="img-thumbnail rounded-circle img-comentarios mb-4"
										src="@/assets/img-pub/maver logo.png"
									/>
								</figure>
								<p
									class="fuente-comentario-texto"
								>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse eros felis, tincidunt a tincidunt eget, convallis vel est. Ut pellentesque ut lacus vel interdum.</p>
							</div>
						</b-carousel-slide>
					</b-carousel>
				</div>
			</div>
		</div> -->

		<!-- Hacemos -->
		<div class="row p-0 m-0 py-3 py-sm-4 pt-lg-5 pb-lg-3">
			<div class="col-12 col-md-6 col-xl-5 offset-xl-2 d-flex align-items-center">
				<div data-aos="fade-right">
					<p class="fuente-seccion-titulo mb-5">Hacemos posible el incremento en tus ventas</p>
					<p
						class="fuente-seccion-texto p-0 m-0 mt-2 mb-4"
					>Trabajando juntos, podrás lograr tus expectativas de venta. Teniendo al alcance una gran variedad de productos, distribución nacional, precios competitivos, financiamiento y compromiso en tiempos de entrega.</p>
				</div>
			</div>
			<div
				class="col-8 offset-2 col-md-6 offset-md-0 col-xl-3 d-flex align-items-center"
				data-aos="fade-left"
			>
				<img class="img-fluid" src="@/assets/img-pub/Ilustraciones-Difarmer-5.jpg" />
			</div>
		</div>

		<!-- Laboratorios -->
		<pm-laboratorios></pm-laboratorios>

		<!-- Carro contacto -->
		<pm-carro-contacto></pm-carro-contacto>

		<!-- Pie pagina -->
		<pm-pie-pagina></pm-pie-pagina>
	</div>
</template>

<script>
	import PmHeader from "@/components/publica/Header"
	import PmLaboratorios from "@/components/publica/Laboratorios"
	import PmCarroContacto from "@/components/publica/CarroContacto"
	import PmPiePagina from "@/components/publica/PiePagina"
	export default {
		components: {
			PmHeader,
			PmLaboratorios,
			PmCarroContacto,
			PmPiePagina
		},
		mounted() {
			//this.ocultarChat()
		}
	}
</script>

<style scoped>
	.img-comentarios {
		width: 150px;
	}

	/* Cabecera */
	.fondo-header {
		/* background-image: url(""); */
		background-repeat: no-repeat, repeat;
		background-size: cover;
		background-position: center;
	}
	.fuente-header-titulo {
		font-weight: 600;
		color: var(--color-blanco);
	}
	.fuente-header-subtitulo {
		color: var(--color-blanco);
	}
	/* Facilitamos Hacemos */
	.fuente-seccion-titulo {
		font-weight: 600;
		font-style: italic;
		color: var(--color-amarillo);
	}
	.fuente-seccion-texto {
		font-family: "Open Sans", sans-serif;
		color: var(--color-gris-dark);
	}
	/* Comentarios */
	.fondo-comentario {
		background-color: var(--color-gris-light);
	}
	.fuente-comentario-titulo {
		font-weight: 600;
		font-style: italic;
		color: var(--color-amarillo);
	}
	.fuente-comentario-texto {
		font-family: "Open Sans", sans-serif;
		color: var(--color-gris-dark);
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		/* Cabecera */
		.fondo-header {
			background-image: url("../../assets/img-pub/Ser cliente 576px.png");
		}
		.fuente-header-titulo {
			font-size: 28px !important;
		}
		.fuente-header-subtitulo {
			font-size: 28px !important;
		}
		/* Facilitamos Hacemos */
		.fuente-seccion-titulo {
			font-size: 20px !important;
		}
		.fuente-seccion-texto {
			font-size: 14px !important;
		}
		/* Comentarios */
		.fuente-comentario-titulo {
			font-size: 20px !important;
		}
		.fuente-comentario-texto {
			font-size: 14px !important;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		/* Cabecera */
		.fondo-header {
			background-image: url("../../assets/img-pub/Ser cliente 576px.png");
		}
		.fuente-header-titulo {
			font-size: 43px !important;
		}
		.fuente-header-subtitulo {
			font-size: 43px !important;
		}
		/* Facilitamos Hacemos */
		.fuente-seccion-titulo {
			font-size: 20px !important;
		}
		.fuente-seccion-texto {
			font-size: 16px !important;
		}
		/* Comentarios */
		.fuente-comentario-titulo {
			font-size: 20px !important;
		}
		.fuente-comentario-texto {
			font-size: 16px !important;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		/* Cabecera */
		.fondo-header {
			background-image: url("../../assets/img-pub/Ser cliente 768px.png");
		}
		.fuente-header-titulo {
			font-size: 43px !important;
		}
		.fuente-header-subtitulo {
			font-size: 43px !important;
		}
		/* Facilitamos Hacemos */
		.fuente-seccion-titulo {
			font-size: 20px !important;
		}
		.fuente-seccion-texto {
			font-size: 16px !important;
		}
		/* Comentarios */
		.fuente-comentario-titulo {
			font-size: 20px !important;
		}
		.fuente-comentario-texto {
			font-size: 16px !important;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		/* Cabecera */
		.fuente-header-titulo {
			font-size: 43px !important;
		}
		.fuente-header-subtitulo {
			font-size: 43px !important;
		}
		/* Facilitamos Hacemos */
		.fuente-seccion-titulo {
			font-size: 28px !important;
		}
		.fuente-seccion-texto {
			font-size: 18px !important;
		}
		/* Comentarios */
		.fuente-comentario-titulo {
			font-size: 28px !important;
		}
		.fuente-comentario-texto {
			font-size: 18px !important;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		/* Cabecera */
		.fuente-header-titulo {
			font-size: 55px !important;
		}
		.fuente-header-subtitulo {
			font-size: 50px !important;
		}
		/* Facilitamos Hacemos */
		.fuente-seccion-titulo {
			font-size: 32px !important;
		}
		.fuente-seccion-texto {
			font-size: 20px !important;
		}
		/* Comentarios */
		.fuente-comentario-titulo {
			font-size: 32px !important;
		}
		.fuente-comentario-texto {
			font-size: 20px !important;
		}
	}
</style>